/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './loader.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/components/loader/loader.component';
import * as i3 from '../../../../app/shared/_services/loader.service';
const styles_LoaderComponent:any[] = [i0.styles];
export const RenderType_LoaderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_LoaderComponent,data:{}});
export function View_LoaderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'loader-container']],[[2,'loader-hidden',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),
      i1.ɵeld(2,0,(null as any),(null as any),6,'div',[['class','loader-overlay']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n          '])),(_l()(),i1.ɵeld(4,0,(null as any),
          (null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n              '])),
      (_l()(),i1.ɵeld(6,0,(null as any),(null as any),0,'img',[['class','loader'],
          ['src','/assets/images/ajax-reload.gif']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,_v) => {
    var _co:i2.LoaderComponent = _v.component;
    const currVal_0:boolean = !_co.show;
    _ck(_v,0,0,currVal_0);
  });
}
export function View_LoaderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'angular-loader',
      ([] as any[]),(null as any),(null as any),(null as any),View_LoaderComponent_0,
      RenderType_LoaderComponent)),i1.ɵdid(1,245760,(null as any),0,i2.LoaderComponent,
      [i3.LoaderService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LoaderComponentNgFactory:i1.ComponentFactory<i2.LoaderComponent> = i1.ɵccf('angular-loader',
    i2.LoaderComponent,View_LoaderComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbG9hZGVyL2xvYWRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vYXBwL3NyYy9hcHAvY29tcG9uZW50cy9sb2FkZXIvbG9hZGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbG9hZGVyL2xvYWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbG9hZGVyL2xvYWRlci5jb21wb25lbnQudHMuTG9hZGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBbY2xhc3MubG9hZGVyLWhpZGRlbl09XCIhc2hvd1wiIGNsYXNzPVwibG9hZGVyLWNvbnRhaW5lclwiPlxuICA8ZGl2IGNsYXNzPVwibG9hZGVyLW92ZXJsYXlcIj5cbiAgICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgICA8aW1nIGNsYXNzPVwibG9hZGVyXCIgc3JjPVwiL2Fzc2V0cy9pbWFnZXMvYWpheC1yZWxvYWQuZ2lmXCIvPlxuICAgICAgICAgIDwvZGl2PlxuICA8L2Rpdj5cbjwvZGl2PlxuIiwiPGFuZ3VsYXItbG9hZGVyPjwvYW5ndWxhci1sb2FkZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUEsOEJBQTRELDRDQUMxRDthQUFBO1VBQUE7TUFBNEIsb0RBQ3BCO1VBQUE7VUFBQSw4QkFBSztNQUNEO1VBQUE7VUFBQSw4QkFBMEQ7TUFDeEQsNENBQ1I7VUFBQSxTQUNGOztJQU5EO0lBQUwsV0FBSyxTQUFMOzs7O29CQ0FBO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/loader/loader.component.ngfactory.ts